import { DateTime, Duration } from '@ksyos/date-time';

interface IEdfMetadata {
    durationSeconds: number;
    endDatetime: string;
    startDatetime: string;
}

interface IFormattedEdfMetadata {
    duration: string;
    end: string;
    start: string;
}

export function formatEdfMetadata(edfMetadata: IEdfMetadata): IFormattedEdfMetadata {
    const start = DateTime.parse(edfMetadata.startDatetime, 'YYYY-MM-DD HH:mm:ss').format('D-M-YYYY HH:mm:ss');
    const end = DateTime.parse(edfMetadata.endDatetime, 'YYYY-MM-DD HH:mm:ss').format('D-M-YYYY HH:mm:ss');
    const duration = Duration.from(edfMetadata.durationSeconds, 'seconds').formatHHmmssAbove24Hours();

    return { duration, end, start };
}
